/**
 * @description Can be swapped with the primary gray color.
 */

const grayNeutral = {
  25: "#FCFCFD",
  50: "#F9FAFB",
  100: "#F3F4F6",
  200: "#E5E7EB",
  300: "#D2D6DB",
  400: "#9DA4AE",
  500: "#6C737F",
  600: "#4D5761",
  700: "#384250",
  800: "#1F2A37",
  900: "#111927",
  950: "#0D121C",
};

export default grayNeutral;
